import getChordName from "../../../../../../common/helpers/getChordName";
import { IPitch, IScore } from "../../../../../../common/types";

const dominantChords = ["D7", "D5", "D3", "D2"];
const diminishedChords = ["s7", "s5", "s3", "s2"];

export const hasChords4 = (score: IScore) => {
    let hasDominant7 = false;
    let hasDiminished7 = false;
    score.bars.forEach(bar => {
        bar?.notes.forEach(note => {
            const name = getChordName(note.p as IPitch[]);
            if (dominantChords.includes(name)) {
                hasDominant7 = true;
            }
            if (diminishedChords.includes(name)) {
                hasDiminished7 = true;
            }
        });
    });
    return {
        hasDominant7,
        hasDiminished7,
    }
};
